import React from 'react';
import { Tooltip } from '../../ui/Tooltip/Tooltip';

interface RelanceAgendaDetailProps {
    icon: React.ReactNode;
    /** Left out to keep the cell, and the column it holds, empty. */
    label: string | null;
    hint: string;
    muted?: boolean;
    testId: string;
}

export const RelanceAgendaDetail: React.FC<RelanceAgendaDetailProps> = ({ icon, label, hint, muted = false, testId }) => {
    const cellClass = `flex items-center gap-xs text-xs font-semibold tabular-nums whitespace-nowrap ${muted ? 'text-content-tertiary' : 'text-content-subtle'}`;
    if (label === null) return <span className={cellClass} data-testid={testId} />;

    return (
        <Tooltip content={hint}>
            <span className={cellClass} data-testid={testId}>
                <span className="flex h-3.5 w-3.5 shrink-0 [&>svg]:h-full [&>svg]:w-full">{icon}</span>
                {label}
            </span>
        </Tooltip>
    );
};
